import styled from 'styled-components';

export const PersuasionTag = styled.div`
    display: flex;
    color: #18A160;
    align-item: center;
    width: 100%;
    img{
        width: 0.9rem; 
        height: 0.9rem; 
        margin-right: 0.6rem;
    }
    ul{
        display:flex;
    }
`;

export const Contanier = styled.li`
    padding-left: 0.8rem;
`;
